<section class="relative">
  @if(userService.userInfo()) {
    <div class="flex items-center gap-2">
      <!-- Avatar & Name Button -->
      <button
        (click)="toggleDropdown()"
        class="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer w-full">
        <!-- Avatar Circle -->
        <div class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-semibold shadow-sm">
          {{ getInitials() }}
        </div>

        <!-- User Name -->
        <div class="flex flex-col items-start flex-1 min-w-0 text-left">
          <span class="text-sm font-semibold text-gray-900 truncate max-w-full">
            {{ userService.userInfo()?.first_name }} {{ userService.userInfo()?.last_name }}
          </span>
          @if(userService.admin()) {
            <span class="text-xs text-blue-600 font-medium">Admin</span>
          }
        </div>

        <!-- Dropdown Arrow -->
        <svg
          class="w-4 h-4 text-gray-500 transition-transform"
          [class.rotate-180]="isDropdownOpen"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </button>
    </div>

    <!-- Dropdown Menu -->
    @if(isDropdownOpen) {
      <div class="absolute bottom-full mb-2 left-0 right-0 rounded-xl bg-white shadow-lg border border-gray-200 overflow-hidden z-50">
        <!-- User Info Section -->
        <div class="px-4 py-3 border-b border-gray-100 bg-gray-50">
          <p class="text-sm font-semibold text-gray-900">
            {{ userService.userInfo()?.first_name }} {{ userService.userInfo()?.last_name }}
          </p>
          @if(userService.userInfo()?.email) {
            <p class="text-xs text-gray-500 mt-1">{{ userService.userInfo()?.email }}</p>
          }
        </div>

        @if(userService.admin()) {
          <button
            (click)="goToAdmin()"
            class="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer">
            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
            </svg>
            <span>Admin Panel</span>
          </button>
        }

        <!-- Menu Items -->
        <div class="py-2">
          <!-- Settings Button -->
          <button
            (click)="goToSettings()"
            class="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer">
            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <span>Settings</span>
          </button>

          <!-- Logout Button -->
          <button
            (click)="logout()"
            class="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors cursor-pointer">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
            <span>Logout</span>
          </button>
        </div>

        <!-- Version -->
        @if (appVersion) {
          <div class="px-4 py-2 border-t border-gray-100 bg-gray-50/80">
            <span class="text-[10px] text-gray-400 font-medium">v{{ appVersion }}</span>
          </div>
        }
      </div>
    }
  }
</section>
